function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesTrouserPresserFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.101 12.321h4.544v-2h-4.544v2zm-2.214-7.214h13.601V4.058H11.887v1.049zm13.601 20.314l-2.124.562V7.107h2.124v18.314zm-4.124 1.091l-4.622 1.222-4.855-14.705V7.107h9.477v19.405zM6.915 14.085l2.972-2v1.105c0 .107.017.212.051.314l3.064 9.283-6.087-8.702zM26.488 2.059H10.887a1 1 0 00-1 1v6.615l-4.933 3.32a.997.997 0 00-.261 1.403l10.575 15.118c.003.003.007.004.009.007a.967.967 0 00.406.322.988.988 0 00.404.097c.081 0 .162-.011.243-.031l.013-.002 10.401-2.751a1 1 0 00.744-.967V3.059a1 1 0 00-1-1z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesTrouserPresserFilled;